export const definitions = {
	supplierShare: {
		definition:
			"Supplier's net sales in the dept/catg/subcatg for the selected time window as compared with Walmart's net sales in the same dept/catg/subcatg.",
	},
	anamoly: {
		definition:
			'An anomalous dept/catg/subcatg is one where the change in supplier dollar share is more/less than expected, and this change is statistically significant. The expected behavior is benchmarked using the reference window, and the selected window performance is compared against it. ',
	},
	anamolyOutperforming: {
		definition:
			'If supplier dollar share of the dept/catg/subcatg is tagged as an anomaly and has gone up as compared to the reference window',
	},
	anamolyUnderperforming: {
		definition:
			'If supplier dollar share of the dept/catg/subcatg is tagged as an anomaly and has gone down as compared to the reference window',
	},
	supplierShareChng: {
		definition:
			'Basis Point Change in Supplier Dollar Share from reference window to selected window',
	},
	netsales: {
		definition: 'Total Sales $ in selected window for the supplier',
	},
	netsalesDollarChng: {
		definition:
			'Difference in Sales $ between reference window & selected window for the supplier',
	},
	netsalesPercentChng: {
		definition:
			'% change in sales between reference window & selected window for the supplier',
	},
	unitsSold: {
		definition: 'Total Sales Quantity in selected window for the supplier',
	},
	unitsSoldChng: {
		definition:
			'Difference in Sales Quantity between reference window & selected window for the supplier',
	},
	unitsSoldPercentChng: {
		definition:
			'% change in sales quantity between reference window & selected window for the supplier',
	},
	rootCause: {
		definition: 'Key Drivers of an anomalous change in Supplier Dollar Share',
	},
	replInstockPercent_ih: {
		definition: 'Ratio of forecasted inventory to actual inventory available	',
	},
	nilPick_ih: {
		definition: 'Total item quantity not available for picking',
	},
	nilPickPercent_ih: {
		definition:
			'Ratio of items not available for picking to the total items ordered',
	},
	traitedStores_ih: {
		definition:
			'Average Traited Store Count of all the items with the replenishment status as Active, Inactive and New.',
	},
	storeWhereReplInstock_ih: {
		definition: 'Number of stores that have Repl Instock %< threshold set',
	},
	weeksOfSupply_ih: {
		definition:
			'Number of weeks of supply available to fulfil orders through store on-hand quantity',
	},
	potentialSalesImpact_ih: {
		definition: 'Potential Sales impact for the item due to low Repl Instock %',
	},
	replenishableInstock_ih_r: {
		definition:
			'Number of items with replenishable instock < set threshold. Default is 95%.',
	},
	potentialSalesImpact_ih_r: {
		definition:
			'Total potential sales miss for all items with low Repl Instock %',
	},
	avgReplenishableInstockPercent_ih_r: {
		definition: 'Average instock % for the items with low instock.',
	},
	avgNilPickPercent_ih_r: {
		definition:
			'Average of the ratio of total items not available for picking to the total items supposed to be picked after substitution for dept/catg/subcatg',
	},
	preSubPercent_ih_r: {
		definition:
			'Average of the ratio of total items available for picking to the total items supposed to be picked before substitution for dept/catg/subcatg',
	},
	inventoryHealth_ih_r: {
		definition: 'Analyze the impact of low replenishment instock % on Sales.',
	},
	aur_pricing: {
		definition: 'AUR of the item in the selected window.',
	},
	aurChange_pricing: {
		definition: '$ Change in AUR between reference and selected window',
	},
	aurPercentChange_pricing: {
		definition: '% Change in AUR between reference and selected window',
	},
	sales_pricing: {
		definition: 'Net Sales of the item in the selected window.',
	},
	salesPercentChng_pricing: {
		definition: '% Change in Net Sales between reference and selected window',
	},
	quantity_pricing: {
		definition: 'Quantity of items sold the selected window.',
	},
	quantityPercentChng_pricing: {
		definition:
			'% Change in quantity of items sold between reference and selected window',
	},
	potentialSalesImpact_pricing: {
		definition:
			'Potential Sales impact for the item due to an increase or decrease in price.',
	},
	increasedInPrice_pricing_r: {
		definition:
			'Number of items in the dept/catg/subcatg that had an increase in AUR in the selected window compared to the reference window.',
	},
	descreasedInPrice_pricing_r: {
		definition:
			'Number of items in the dept/catg/subcatg that had a decrease in AUR in  the selected window compared to the reference window.',
	},
	potentialSalesImpact_pricing_r: {
		definition:
			'Net potential sales impact for all items that had an increase or decrease in price in the selected window compared to the reference window.',
	},
	pricingChange_pricing_r: {
		definition: 'Analyze the impact of change in item price on sales.',
	},
	traitedStores_pod: {
		definition:
			'Average Traited Store Count of all the items with the replenishment status as Active, Inactive and New.',
	},
	traitedStoresChange_pod: {
		definition:
			'Difference in Average Traited Store Count between reference and selected window',
	},
	validstoreCount_pod: {
		definition:
			'Average Valid Store Count of all the items with the replenishment status as Active',
	},
	validstoreCountChg_pod: {
		definition:
			'Difference in Average Valid Store Count between reference window and selected window',
	},
	posStoreCount_pod: {
		definition: 'Average POS Store Count of all the items with sales > 0',
	},
	posStoreCountChg_pod: {
		definition:
			'Difference in Average POS Store Count between reference window and selected window',
	},
	potentialSalesImpact_pod: {
		definition:
			'Potential Sales impact for the item due to change in number of traited stores.',
	},
	increasedInTraitedStore_pod_r: {
		definition:
			'Number of items that had an increase in traited store count in the selected window compared to the reference window',
	},
	descreasedInTraitedStore_pod_r: {
		definition:
			'Number of items that had a decrease in traited store count in the selected window compared to the reference window',
	},
	potentialSalesImpact_pod_r: {
		definition:
			'Net potential sales impact for all items that had an increase or decrease in number of traited stores in the selected window compared to the reference window.',
	},
	pod_r: {
		definition:
			'Analyze the impact of change in number of traited stores on sales.',
	},
	addedRemoved_assort: {
		definition:
			'Identifies if an item was added for the first time in the selected window or was deleted in the selected window',
	},
	date_assort: {
		definition: 'Date of addition or deletion of the item',
	},
	potentialSalesImpact_assort: {
		definition:
			'Potential Sales impact resulting from an addition or deletion of the item.',
	},
	added_assort_r: {
		definition:
			'Number of  items added in the selected window for the dept/catg/subcatg',
	},
	removed_assort_r: {
		definition: 'Number of items that were deleted in the selected window',
	},
	potentialSalesImpact_assort_r: {
		definition:
			'Net potential sales impact for all items that were added or deleted in the selected window compared to the reference window.',
	},
	assortmentChange_assort_r: {
		definition: 'Analyze the impact of addition or deletion of items on sales.',
	},
	stores_sd: {
		definition:
			'Store Number where the repl instock has dropped below the set threshold.',
	},
	dcNumber_sd: {
		definition: 'DC Number for the Distribution Center replenishing the item.',
	},
	dcName_sd: {
		definition: 'DC Name for the Distribution Center replenishing the item.',
	},
	replInstockPct_sd: {
		definition:
			'It is a measurement on the percentage of the inventory that is getting replenished that becomes in stock inventory.',
	},
	storeOnHand_sd: {
		definition: 'The quantity of an item which is on-hand at this store.',
	},
	storeOnOrder_sd: {
		definition:
			'The number of units on a purchase order allocated specifically to the store.',
	},
	storeInTransit_sd: {
		definition:
			'The number of units invoiced by DC to the store but not yet received and finalized.',
	},
	storeInWarehouse_sd: {
		definition:
			'The number of units received by the DC which are allocated specifically to a store but not yet shipped (invoiced).',
	},
	dcOnHand_sd: {
		definition: 'The on hand whpk at the replenishing Distribution Center.',
	},
	dcOnOrder_sd: {
		definition: `The whpk's currently on order to the replenishing Distribution Center.`,
	},
	dcWksOfSplyOnHand_sd: {
		definition:
			'The a measure of how many weeks the warehouse on hand inventory quantity, for a particular item, will last given the current average warehouse sales quantity.',
	},
	units_sd: {
		definition:
			'Total number of units sold to customers for transactions online and in store.',
	},
	sales_sd: {
		definition:
			'Revenue as recorded financially (may also see net sales labeled as revenue in reporting). For all sales except marketplace (MP) and services, net sales = GMV. However, for MP and services sales, net sales is commission.',
	},
	nilPickPct_sd: {
		definition:
			'The percentage of items that were not fulfilled for scheduled orders. This is reported in a percent.',
	},
	nilPickQty_sd: {
		definition:
			'This is a measure of the of units not picked or substituted by a store. In other words, Quantity Not Picked',
	},
	store_wk_supply_sd: {
		definition: `Estimated weeks the store's on hand will last, given the average sales.`,
	},
	units_store_wk_sd: {
		definition:
			'The average of the number of units for the total net sales, per distinct valid store, over the number of weeks during the selected Walmart for the included stores.',
	},
	dollar_store_wk_sd: {
		definition:
			'The average of the total net sales, per distinct valid store, over the number of weeks during the selected Walmart week for the included stores.',
	},
};
